import { Component, Input } from '@angular/core';

import { getRowStatusColor } from './status-helpers';


@Component({
  moduleId: module.id,
  selector: 'status-renderer',
  styleUrls: ['status-renderer.component.scss'],
  templateUrl: 'status-renderer.component.html',
})
export class StatusRendererComponent {
  @Input() row: any;
  @Input() statusColorMap: any; // Example: {'1': 'yellow', '2': 'green', etc..}

  get statusColor(): string {
    return getRowStatusColor(this.statusColorMap, this.row);
  }
}
